import Model from 'models/Model';
import MediaFile from '../mediaFile/Model.MediaFile';
import StatementBalanceEmailTemplate from '../statementBalanceEmailTemplate/Model.StatementBalanceEmailTemplate';

export default class StatementBalanceEmailTemplateAttachment
  extends Model<Model.IStatementBalanceEmailTemplateAttachment>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IStatementBalanceEmailTemplateAttachment>
{
  id: number;
  languageIsoCode: Locale.Languages;
  statementBalanceEmailTemplate: StatementBalanceEmailTemplate;
  statementBalanceEmailTemplateId: number;
  mediaFile: MediaFile;
  mediaFileId: number;

  constructor(
    data:
      | Partial<Model.IStatementBalanceEmailTemplateAttachment>
      | Utils.FormData<Model.IStatementBalanceEmailTemplateAttachment>,
    language?: Locale.Languages
  ) {
    super(
      {
        statementBalanceEmailTemplate: StatementBalanceEmailTemplate,
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
